const userGridData = [
    {
        id: 1,
        font: 'D',
        name: 'David McHenry',
        text: 'UI/UX Designer',
        email: 'david@willo.nu'
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Frank Kirk',
        text: 'Frontend Developer',
        email: 'frank@willo.nu'
    },
    {
        id: 3,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Rafael Morales',
        text: 'Backend Developer',
        email: 'Rafael@willo.nu'
    },
    {
        id: 4,
        font: 'M',
        name: 'Mark Ellison',
        text: 'Full Stack Developer',
        email: 'mark@willo.nu'
    },
    {
        id: 5,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Minnie Walter',
        text: 'Frontend Developer',
        email: 'minnie@willo.nu'
    },
    {
        id: 6,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Shirley Smith',
        text: 'UI/UX Designer',
        email: 'shirley@willo.nu'
    },
    {
        id: 7,
        font: 'J',
        name: 'John Santiago',
        text: 'Full Stack Developer',
        email: 'john@willo.nu'
    },
    {
        id: 8,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Colin Melton',
        text: 'Backend Developer',
        email: 'colin@willo.nu'
    },
];

export { userGridData };